export enum OcbAgentTypes {
    OnPremise = 0,
    AzureFunction = 1,
}
